import DeviceTypeLabel from 'components/device/DeviceTypeLabel';
import { PredefinedDataRow } from 'components/tables/data/predefined/types';

/**
 * Column for the device type.
 */
export default function DeviceTypeColumn({ data: { deviceType } }: { data: PredefinedDataRow }) {
  return <DeviceTypeLabel deviceType={deviceType.deviceTypeId} />;
}
